// @ts-check
import { ModuleProcessMappings } from '@erpagroapp/common';
import {
  ConfigurationParameterReturnType,
  ConfigurationParameterSource,
} from '../enums';
import { defineConfig, defineDefaultProps } from '../helpers';

const defaultProps = defineDefaultProps(/** @type {const} */ ({
  loadingRules: {
    requiredModuleIds: [
      ModuleProcessMappings.Alhondiga.Id,
    ],
    requiredProcessIds: [
      ModuleProcessMappings.Alhondiga.Processes.ManageAuction.Id,
    ],
  },
}));

export function alhondigas() {
  return defineConfig({
    PermitirVenderPartidasMultiplesVentas: {
      source: ConfigurationParameterSource.ERP,
      component: 'Alhondigas',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    LecturaContinuaPartidasEnListinSubasta: {
      source: ConfigurationParameterSource.ERP,
      component: 'Alhondigas',
      returnType: ConfigurationParameterReturnType.BOOLEAN,
      defaultValue: false,
      ...defaultProps,
    },
    MaximoNumeroListinesAbiertos: {
      source: ConfigurationParameterSource.ERP,
      component: 'Alhondigas',
      returnType: ConfigurationParameterReturnType.NUMBER,
      defaultValue: null,
      ...defaultProps,
    },
    PrefijoCodigosClientes: {
      source: ConfigurationParameterSource.ERP,
      component: 'Alhondigas',
      returnType: ConfigurationParameterReturnType.STRING,
      defaultValue: null,
      ...defaultProps,
    },
    DigitosNivel6: {
      source: ConfigurationParameterSource.ERP,
      component: 'Alhondigas',
      returnType: ConfigurationParameterReturnType.NUMBER,
      defaultValue: null,
      ...defaultProps,
    },
  });
}
